export default "__VITE_ASSET__DKIUwmk1__"